import script from "./QHeaderSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./QHeaderSupport.vue?vue&type=script&setup=true&lang=js"

import "./QHeaderSupport.vue?vue&type=style&index=0&id=06d38fab&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d38fab"]])

export default __exports__